/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*******************************************************************************************************************************************/
/* Geo location
/*******************************************************************************************************************************************/

function getReleatedUrl({ url, prettyUrl }) {
  var pathBase = window.hreflang.pathUrl;
  var getPath = window.hreflang.urls?.[url];
  var collectionHandle = window.hreflang.collectionHandle?.[url];

  if (collectionHandle?.handle) {
    var pathBase = pathBase.replace('{handle}', collectionHandle.handle)
  } else {
    var pathBase = pathBase.replace('/collections/{handle}', '');
  }

  var baseUrl = prettyUrl ?? url;
  var url = baseUrl;

  if (getPath?.handle) {
    var url = baseUrl + pathBase + getPath?.handle ?? '';
  }

  return url;
}

function getGeoData( callback ) {
  var api = 'https://get.geojs.io/v1/ip/country.json';

	fetch(api).then(function(response) {
		return response.json()
	}).then(function(data) {
		callback(data)
	})
}

var geoCookie = getCookie('geolocation')
var geopopup = document.querySelector('[data-geopopup]')

// Also add check for set cookie
if ( geopopup != null && !geoCookie ) {
	var suggest = geopopup.querySelector('[data-suggest]')
	var closeModal = geopopup.querySelectorAll('[data-close]')

	getGeoData(function(data) {
		var countryCode = data.country.toLowerCase();

		var findRelated = Object.keys(window.sites).filter(function(item) {
			return item == countryCode.toLowerCase()
		})

		if ( findRelated.length ) {
			var related = window.sites[findRelated[0]]
			var code = related?.code ?? findRelated[0]

			// Don't open if already on suggested shop
			if ( code != window.theme.locale ) {
				openGeopopup(related)
			} else {
				setCookie('geolocation', true, 30)
			}
		} else {
			var related = window.sites['eu'] // Default
			var code = related?.code ?? 'eu'

			if ( code != window.theme.locale ) {
				openGeopopup(related)
			} else {
				setCookie('geolocation', true, 30)
			}
		}
	})


	closeModal.forEach(function(close) {
		close.addEventListener('click', function(e) {
			e.preventDefault()
			closeGeopopup()
		})
	})

	function openGeopopup( related ) {
		geopopup.classList.add('is-open')
		geopopup.setAttribute('aria-hidden', false)

		if ( related && suggest ) {
      var url = getReleatedUrl(related);
			var flag = related?.flag ? '<img src="' + related.flag + '" />' : null
			var label = flag ? flag + related.label : related.label

			suggest.href = 'https://' + url
			suggest.innerHTML = label
		}
	}

	function closeGeopopup() {
		geopopup.classList.remove('is-open')
		geopopup.setAttribute('aria-hidden', true)
		setCookie('geolocation', true, 30)
	}
}



function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}


function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}


/*******************************************************************************************************************************************/
/* Header country dropdown
/*******************************************************************************************************************************************/

const countryWrappers = document.querySelectorAll('.js-countryWrapper');

if (countryWrappers.length) {
  const siteKeys = Object.keys(window.sites).map((key) => key);
  let currentSiteKey;

  if (Shopify.shop === 'sisi-copenhagen-eu.myshopify.com') {
    currentSiteKey = 'eu';
  } else {
    currentSiteKey = siteKeys.find(key => key.toLowerCase() === window.Shopify.country.toLowerCase());
  }

  const currentSite = window.sites[currentSiteKey];

  if (currentSite) {
    siteKeys.splice(siteKeys.indexOf(currentSiteKey), 1);
    siteKeys.unshift(currentSiteKey);
  }

  countryWrappers.forEach(wrapper => {
    const dropdownBtn = wrapper.querySelector('.js-dropdownBtn');
    const dropdownBtnText = dropdownBtn?.querySelector('.js-text');
    const dropdown = wrapper.querySelector('.js-dropdown');

    dropdownBtnText.textContent = siteKeys[0];

    const currentPath = window.location.pathname;
    let productPath = undefined;
    if (currentPath.includes('/products/')) {
      productPath = '/products/' + currentPath.split('/products/')[1];
    }

    siteKeys.forEach(key => {
      const link = document.createElement('a');
      var relatedPath = getReleatedUrl(window.sites[key]);
      link.href = `https://${relatedPath}`;

      const image = document.createElement('img');
      image.src = window.sites[key].flag;
      link.appendChild(image);

      const text = document.createElement('span');
      text.textContent = key;
      link.appendChild(text);

      dropdown.appendChild(link);
    });

    dropdownBtn.addEventListener('click', () => {
      dropdownBtn.classList.toggle('is-open');
      dropdown.classList.toggle('is-open');
    });

    document.addEventListener('click', (e) => {
      if (!dropdownBtn.contains(e.target) && !dropdown.contains(e.target)) {
        dropdownBtn.classList.remove('is-open');
        dropdown.classList.remove('is-open');
      }
    });
  });
}
